import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IServerAdminSettings } from '../../../settings/types/ISite';
import { ISiteAdminSettings, ISiteSubscriptionSettings } from '../../../settings/types/ISiteSettingsForSiteAdmin';

export interface ICreateSiteParams {
  settings: IServerAdminSettings;
  siteAdminSettings?: ISiteAdminSettings;
  subscriptionSettings?: ISiteSubscriptionSettings;
}

export interface ICreateSiteResult extends IResult {
}

export class CreateSiteRequest extends Request<ICreateSiteParams, ICreateSiteResult> {
  constructor(params: ICreateSiteParams) {
    super('createSite', params);
  }
}
